import { IReduxAction } from '../../views/interfaces';
import { GET_RATING_REVIEWS_SUCCESS } from '../actions';

const initialState = {
  data: null  
};

export const ratingReviewsReducer = (state = initialState, { type, payload }: IReduxAction) => {
  switch (type) {
    case GET_RATING_REVIEWS_SUCCESS: {
      return { ...state, data: payload };
    }
    default:
      return state;
  }
}; 